module.exports = __webpack_public_path__ + "static/media/living.0acb2aed.jpg";